import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Box, Flex } from "theme-ui";
import { rawColorValues, Label2, Label3, ArtDirectedImage, ButtonVariants, HeadingRegularVariants, ImageVariants } from "../../index";
export const ArticleListItem = ({ title, additional_label, text, link, tags, imageNode, imageAspectRatio = ImageVariants.ratio_4x3 }) => {
    return (_jsxs(Box, { className: "article-list-item", sx: {
            borderBottomStyle: "solid",
            borderBottomWidth: "1px",
            borderBottomColor: "grey.3",
            pb: 24,
            display: [null, null, null, "flex"],
            flex: [null, null, null, 1],
            width: "100%",
            cursor: link ? "pointer" : "default",
            ":hover a": {
                textDecoration: link ? "underline" : "none"
            }
        }, children: [_jsxs(Flex, { children: [imageNode && (_jsx(Box, { sx: {
                            width: [128, null, 160],
                            mr: 16
                        }, children: _jsx(Box, { sx: {
                                width: "100%",
                                variant: `images.${imageAspectRatio}`
                            }, children: _jsx(ArtDirectedImage, { imageNode: imageNode, imageAlt: "" }) }) })), _jsxs(Flex, { sx: {
                            flexDirection: "column",
                            flex: 1
                        }, children: [_jsx("h6", { sx: {
                                    color: "grey.0",
                                    variant: `text.${HeadingRegularVariants.sixth}`
                                }, children: title }), _jsx(Box, { sx: {
                                    color: "grey.1",
                                    mt: 4,
                                    maxWidth: "40ch",
                                    variant: `text.${HeadingRegularVariants.sixth}`
                                }, children: text })] })] }), _jsx(Box, { sx: {
                    mt: [16, null, null, 0],
                    ml: [null, null, null, 24],
                    flex: [null, null, null, 1],
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    justifyContent: ["flex-start", null, null, "flex-end"]
                }, children: tags &&
                    tags.map((tag, idx) => {
                        return (_jsx(Box, { sx: {
                                variant: `buttons.${ButtonVariants.actionableTagSecondary}`,
                                cursor: "default",
                                mb: 8,
                                mr: 8,
                                width: "auto",
                                "&:last-child": {
                                    mr: 0
                                },
                                ":hover": {
                                    color: "grey.1",
                                    bg: "inherit"
                                }
                            }, children: _jsx(Label3, { sx: { textAlign: "center" }, children: tag.label }) }, `tag-${idx}`));
                    }) }), (additional_label || link) && (_jsxs(Flex, { children: [additional_label && additional_label.length > 0 && (_jsx(Label2, { sx: {
                            color: "grey.1",
                            flex: 1,
                            justifyContent: "flex-end",
                            mt: [16, null, null, 0],
                            ml: [0, null, null, 16]
                        }, children: additional_label })), link && (_jsx(Label2, { sx: {
                            mt: [16, null, null, 0],
                            textAlign: "right",
                            ml: [0, null, null, 16],
                            "> a": {
                                color: rawColorValues["blue"][0] + " !important",
                                textDecoration: "none"
                            },
                            "> a:hover": {
                                color: rawColorValues["blue"][1] + " !important",
                                textDecoration: "underline"
                            }
                        }, children: link }))] }))] }));
};
//# sourceMappingURL=ArticleListItem.js.map